import { render, staticRenderFns } from "./NewUserOnboardingDialog.vue?vue&type=template&id=28cc2323&scoped=true"
import script from "./NewUserOnboardingDialog.vue?vue&type=script&lang=ts"
export * from "./NewUserOnboardingDialog.vue?vue&type=script&lang=ts"
import style0 from "./NewUserOnboardingDialog.vue?vue&type=style&index=0&id=28cc2323&prod&scoped=true&lang=scss"
import style1 from "./NewUserOnboardingDialog.vue?vue&type=style&index=1&id=28cc2323&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cc2323",
  null
  
)

export default component.exports